import { Button, Input, InputNumber, Space, Tag, Message } from "@arco-design/web-react";
import { IconCopy } from "@arco-design/web-react/icon";
import React, { useEffect, useState } from "react";
import { copy } from "../utils/copy";

const TextArea = Input.TextArea;
const ArcCalculation = () => {
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");

  // Macro generator states
  const [hexInput, setHexInput] = useState("");
  const [alarmNo, setAlarmNo] = useState();
  const [macroOutput, setMacroOutput] = useState("");
  const STORAGE_KEY = "cc_values_v1";
  const loadSaved = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };
  const save = (data) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  };
  useEffect(() => {
    const saved = loadSaved();
    if (saved) {
      if ("input" in saved) setInput(saved.input);
      if ("output" in saved) setOutput(saved.output);
      if ("hexInput" in saved) setHexInput(saved.hexInput);
      if ("alarmNo" in saved) setAlarmNo(saved.alarmNo);
      if ("macroOutput" in saved) setMacroOutput(saved.macroOutput);
    }
  }, []);
  useEffect(() => {
    save({ input, output, hexInput, alarmNo, macroOutput });
  }, [input, output, hexInput, alarmNo, macroOutput]);
  const onConvert = async () => {
    try {
      const base = (process.env.REACT_APP_API || "http://localhost:3008").replace(/\/$/, "");
      const url = /\/encode$/.test(base) ? base : `${base}/encode`;
      console.log(url, "url");

      const resp = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: input, uppercase: true, sep: " " }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || !data || typeof data.hex !== "string") {
        throw new Error(data && data.error ? data.error : "服务异常");
      }
      const code = `${data.hex}`.replaceAll(" ", "");
      setOutput(code);
      setHexInput(code);
    } catch (e) {
      setOutput(`转换失败：${e.message || e}`);
    }
  };
  const reset = () => {
    setInput("");
    setOutput("");
  };
  const onGenerate = () => {
    const normalizedHex = (hexInput || "").trim().replace(/\s+/g, " ").toUpperCase();
    const n = Number(alarmNo);
    if (!Number.isFinite(n) || n < 0 || n > 200) {
      setMacroOutput("非法条件");
      return;
    }
    const prefix = `#${3000 + n}`;
    const result = `${prefix} (@0400 ${normalizedHex}02@)`;
    setMacroOutput(result);
  };
  return (
    <div className="cc-wrapper">
      <TextArea
        placeholder="请在此处输入要转换的字符..."
        style={{ minHeight: "8em", width: "90%" }}
        value={input}
        onChange={(value) => setInput(value)}
      />
      <div className="options-wrapper">
        <Space size="large" align="center">
          <Tag size="large">GB18030</Tag>
          <span>转</span>
          <Tag size="large">十六进制</Tag>
        </Space>
        <br />
        <br />
        <Space>
          <Button type="primary" htmlType="submit" onClick={onConvert}>
            立即转换
          </Button>
          <Button onClick={reset} style={{ marginLeft: 30 }}>
            重置内容
          </Button>
        </Space>
      </div>
      <div className="textarea-copy-wrapper" style={{ position: "relative", width: "90%" }}>
        <TextArea
          id="cc_output"
          style={{ minHeight: "8em", width: "100%" }}
          value={output}
          onChange={setOutput}
          placeholder="转换结果在此处显示...（可编辑）"
        />
        <Button
          aria-label="复制转换结果"
          type="secondary"
          size="mini"
          icon={<IconCopy />}
          style={{ position: "absolute", right: 8, bottom: 8 }}
          onClick={() => copy(null, "#cc_output")}
        />
      </div>

      {/* 宏报警代码生成 */}
      <div className="options-wrapper" style={{ marginTop: 20, width: "90%" }}>
        {/* <Space size="large" align="center" wrap>
          <Tag size="large">16 进制代码：</Tag>
          <Input
            style={{ width: "100%", maxWidth: 420 }}
            allowClear
            placeholder="如：CAE4 C8EB B4E1 CEF3"
            value={hexInput}
            onChange={setHexInput}
          />
        </Space> */}
        <br />
        <Space size="large" align="center" style={{ marginTop: 10 }} wrap>
          <Tag size="large">宏报警号：</Tag>
          <InputNumber
            style={{ width: 100 }}
            placeholder="0 ~ 200"
            min={0}
            max={200}
            value={alarmNo}
            onChange={(v) => {
              setAlarmNo(v);
              const n = Number(v);
              if (Number.isFinite(n) && (n < 0 || n > 200)) {
                Message.warning("宏报警号超出范围：应为 0~200");
              }
            }}
          />
          <span>（0~200）</span>
        </Space>
        <br />
        <Space style={{ marginTop: 12 }}>
          <Button type="primary" onClick={onGenerate}>
            宏报警代码生成
          </Button>
        </Space>
      </div>
      <div
        className="textarea-copy-wrapper"
        style={{ position: "relative", width: "90%", marginTop: 10, marginBottom: 20 }}
      >
        <TextArea
          id="cc_macro_output"
          style={{ minHeight: "6em", width: "100%" }}
          value={macroOutput.replaceAll(" ", "")}
          onChange={setMacroOutput}
          placeholder="#3000 (@0400         02@)（可编辑）"
        />
        <Button
          aria-label="复制宏报警代码"
          type="secondary"
          size="mini"
          icon={<IconCopy />}
          style={{ position: "absolute", right: 8, top: 8 }}
          onClick={() => copy(null, "#cc_macro_output")}
        >
          复制
        </Button>
      </div>
    </div>
  );
};
export default ArcCalculation;
